import { assignProps } from '@nzyme/utils/assignProps.js';
/**
 * Define the endpoint
 * @_NO_SIDE_EFFECTS_
 */
export const defineEndpoint = assignProps(defineEndpointBase, {
    output: endpointOutput,
});
/**
 * Define the endpoint base function
 * @__NO_SIDE_EFFECTS_
 */
function defineEndpointBase(endpoint) {
    return {
        ...endpoint,
        $input: endpoint.input,
        $output: endpoint.output,
    };
}
function endpointOutput() {
    return {};
}
//# sourceMappingURL=defineEndpoint.js.map